import React from 'react';
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Radio from "@material-ui/core/Radio/Radio";
import { useTranslation } from 'react-i18next';


const FieldRadio = ({name, scheme, defaultValue, refs}) => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const [state, setValue] = React.useState({
        value: Number(defaultValue ? defaultValue : scheme.type.default),
    });
    const handleChange = (e) => {
        setValue({...state, value: Number(e.target.value)});
    };
    return (
        <React.Fragment>
            <input type="hidden" ref={input => refs[name] = input} value={state.value} />
            <FormControl component="fieldset" size="small" required={scheme.required === true}>
                <FormLabel component="legend">{currentLang === 'en' ? scheme.label_en : scheme.label}</FormLabel>
                <RadioGroup
                    aria-label={name}
                    name={name}
                    value={state.value}
                    onChange={handleChange}>
                    {scheme.type.values.map(value => {
                        return (
                            <FormControlLabel
                                key={value.id}
                                value={Number(value.id)}
                                control={<Radio color="primary"/>}
                                label={currentLang === 'en' ? value.value_en : value.value} />
                        )
                    })}
                </RadioGroup>
            </FormControl>
        </React.Fragment>
    );
};
export default FieldRadio;